import api from "../../../api/api";

// initial state
const state = () => ({
	contact: {}
})

// getters
const getters = {}

// actions
const actions = {
	getContact({commit,state}){
		return new Promise((resolve,reject) => {
			api.getContact().then(response => {
				commit('SET_CONTACT', response.data[0])
				resolve({'success':response.data[0]});
			}).catch(error => {
				const errorResponse = error && error.response && error.response.data;
				resolve({'errors':errorResponse && errorResponse.message});
			})
		})
	},

	updateContact({commit,state},contact){
		return new Promise((resolve,reject) => {
			api.updateContact(1,contact).then(response => {
				commit('SET_CONTACT', response.data)
				resolve(response.data);
			}).catch(error => {
				const errorResponse = error && error.response && error.response.data;
				resolve({'errors':errorResponse && errorResponse.message});
			})
		})
	}
}

// mutations
const mutations = {
	SET_CONTACT(state, contact){
		state.contact = contact;
	},
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}